export default __webpack_public_path__ + "static/media/GenomeBioExpo_TimeTable_20220729_ko.00632742.png";